import * as React from "react";

import * as cx from "classnames";
import SelectGrid from "@tunnel-components/@sharded/@widgets/select";
import * as Styled from "@tunnel-components/@sharded/@styled/styled";
import StyledIcon from "@tunnel-components/@sharded/@widgets/icons/component";
import * as i18next from "i18next";
/**
 * @function Component : Composant fonctionnel
 * @description : fonction simple qui prend en argument un objet props
 * et rend du contenu sous forme d'élement  JSX
 * @param { ComponentInterface } props
 * @returns { JSX.Element }
 * @implements { ComponentInterface }
 * @type { React.FunctionComponent }
 * @infos "https://reactjs.org"
 */
const Component: React.FunctionComponent<any> = (
  props: ComponentInterface
): JSX.Element => {
  /**
   * @affectation
   * @description :
   * Affectation par décomposition des élements de l'objet (props)
   * les élements existent ou sont créés dans ( ou par) la @class container
   * fonctions , méthodes, variables , objets, tableaux ...., sont les éléments
   * susceptibles de subir une affectation par décomposition
   * exemple : const { elements } = objet ;
   * @infos "https://developer.mozilla.org"
   */

  const {
    onSubmit,
    onChangePatterns,
    onClosePattern,
    /* patternfalseAlarm, */ items,
    /* selectedValue,*/ actionFalseAlarmPatternsError,
  } = props;
  /**
   * @expression return()
   * @description :
   * Cette expression transforme un élément JSX en élément HTML
   * @external
   * @name react-datepicker
   * @name react-custom-scrollbars
   * @name lodash
   * @name i18next
   * @name react-datepicker
   * @infos "https://reactjs.org"
   */
  return (
    <div className="PatternFalseAlarm animated slideInUp">
      <div className="patternHeader">
        <span>{i18next.t("fausse alarme")}</span>
        <span style={{ float: "right" }} onClick={onClosePattern}>
          <Styled.Icon
            isrotate={false}
            style={{ width: "13px", right: "10px" }}
          >
            <StyledIcon arrowWite={true} />
          </Styled.Icon>
        </span>
      </div>

      <div className="patternContent">
        <div className="patternContentInsider">
          <div className={cx("patternContentInsiderSelect")}>
            <SelectGrid
              error={actionFalseAlarmPatternsError}
              incident={true}
              selectedOptions={items}
              onGetIdentifiantItem={onChangePatterns}
              placeholder={i18next.t("rechercher un incident ...")}
            />
          </div>
          <div className="modalBtn" style={{ textAlign: "center" }}>
            <span className="borderGradian" onClick={onSubmit}>
              {" "}
              <span
                className="btnSecondary "
                style={{ backgroundColor: "white", overflow: "visible" }}
              >
                <span className="textGradianlarge">{i18next.t("valider")}</span>
              </span>
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

/**
 * @interface ComponentInterface
 * @description :
 * Cette interface définit le model du props
 */
interface ComponentInterface {
  label?: any;
  onSubmit?: any;
  onChangePatterns?: any;
  patternfalseAlarm?: any;
  items?: any;
  actionFalseAlarmPatternsError?: any;
  selectedValue?: any;
  onSearchValue?: any;
  style?: any;
  onClosePattern?: any;
}
export default React.memo(Component);



// WEBPACK FOOTER //
// ./src/apps/tunnel/components/@sharded/widgets/patterns-incident/component.tsx